<template>
<div class="banner">
    <navComponent :activeName="activeName"></navComponent>
    <div class="banner-content banner-fade-in">
       <div class="banner-content-center">
           <el-carousel indicator-position="outside" height="39.375rem" arrow="always" :autoplay="true">
              <el-carousel-item v-for="item in swiperList" :key="item.id">
                <div class="banner-img" :style="{backgroundImage: `url(${item.img})`}"></div>
              </el-carousel-item>
          </el-carousel>
          <div class="banner-info-content" ref="animate">
            <div class="banner-info">
              <div class="title">
                <div class="title-top">Discover the</div>
                <div class="title-bottom">Gongga Mountain</div>
            </div>
            <div class="include">
              Customized journeys for extraordinary experiences.
            </div>
          </div>
       </div>
      </div>
    </div>
  </div>
</template>
<script>
import bannerSwiper from '/js/bannerSwiper/bannerSwiper.js'
import navComponent from '/components/pc/headerComponent/navComponent.vue'
export default{
  components:{
    navComponent
  },
  data() {
      return {
          activeName: 'first',
          screenWidth: window.innerWidth,
          swiperList: [],
      };
    },
    created() {
      this.swiperList = bannerSwiper.bannerList
    },

    mounted(){
      const contentElement = this.$refs.animate;
      contentElement.classList.add('animate');
      // window.addEventListener('scroll', () => {
      //   const scrollTop = window.scrollY || document.documentElement.scrollTop;
      //   if (scrollTop > 88) {
      //     this.isNavScroll = true
      //   } else {
      //     this.isNavScroll = false
      //   }
      // });
    },
}
</script>
<style scoped lang="scss">
@import '/style/pc/common/fadeIn.scss';
@import '/style/phone/header/homeBanner.scss';
/* 定义动画效果：从下往上移动 */
@keyframes slide-up {
    0% {
      transform: translateY(20%);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
/* 触发动画效果 */
.animate {
  animation: slide-up 1s ease-out forwards;
}
::v-deep .el-carousel__arrow{
    width: 3.75rem;
    height: 3.75rem;
    background-color: rgba(255, 255, 255, 0.4);
}

::v-deep .el-carousel__arrow{
    display: none;
}

::v-deep .el-carousel--horizontal{
    width: 100%;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 1.125rem;
    opacity: 0.75;
    line-height: 18.75rem;
    margin: 0;
}

::v-deep .el-carousel__indicators{
    position: absolute;
    z-index: 10;
}
::v-deep .el-carousel__indicators{
  display: none;
}
// ::v-deep .el-carousel__button{
//   width: 10px;
//   height: 10px;
//   background-color: #FFF;
//   border-radius: 50%;
//   opacity: 1;
//   border: none;
//   padding: 0;
//   margin: 0;
//   &:hover{
//     background-color: #FFF;
//   }
// }
.main {
    font-family: Inter;
    width: 100%;
    background: #FCFCFD;
    .banner {
        width: 100%;
        .banner-img{
            width: 100%;
            height: 100%;
        }
        .banner-content {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            .banner-content-center{
                // max-width: 128rem;
                height: 100%;
                width: 100%;
                position: relative;
                display: flex;
                justify-content: center;
                margin-top: 5.5rem;
                .banner-img{
                  width: 100%;
                  height: 100%;
                  background-size: cover;
                  background-position: center;
                  background-repeat: no-repeat;
                }
            }
        }
        .banner-info-content{
          opacity: 0;
          transform: translateY(20%);
          position: absolute;
          z-index: 9;
        }
        .banner-info {         
            .title {
                color: #FFF;
                text-align: center;
                font-size: 4rem; 
                font-weight: 800;
                margin: 7.6875rem 0 15.1875rem 0;
                .title-top,.title-bottom{
                  font-family: Butler;
                }
            }
            .include {
                color: #FFF;
                text-align: center;
                font-family: Inter;
                font-size: 1.25rem;
                line-height: 160%; 
            }
        }
    }
}
</style>